/**
 * EBP Mobile Fixes — Sticky Price Bar + Badge Relocation + Qty Fix
 * Only active on screens <= 749px (Shopify mobile breakpoint)
 */
(function() {
  'use strict';

  if (window.innerWidth > 749) return;

  document.addEventListener('DOMContentLoaded', function() {

    /* ---- 1. STICKY PRICE BAR ---- */
    try {
      var priceContainer = document.querySelector('.product-price-container');
      var variantArea = document.querySelector('.variations, variant-selects');
      var priceEl = priceContainer ? priceContainer.querySelector('.price-item--last, .price-item--regular, .price-item') : null;
      if (priceContainer && variantArea && priceEl) {
        var stickyBar = document.createElement('div');
        stickyBar.className = 'ebp-mobile-sticky-price';
        stickyBar.innerHTML =
          '<span class="sticky-price-label">Price:</span>' +
          '<span class="sticky-price-value">' + priceEl.textContent.trim() + '</span>';

        variantArea.parentNode.insertBefore(stickyBar, variantArea);

        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              stickyBar.classList.remove('is-visible');
            } else {
              var rect = priceContainer.getBoundingClientRect();
              if (rect.bottom < 0) {
                stickyBar.classList.add('is-visible');
              } else {
                stickyBar.classList.remove('is-visible');
              }
            }
          });
        }, { threshold: 0, rootMargin: '0px' });

        observer.observe(priceContainer);

        var mutObs = new MutationObserver(function() {
          var p = priceContainer.querySelector('.price-item--last, .price-item--sale, .price-item--regular, .price-item');
          if (p) {
            var val = stickyBar.querySelector('.sticky-price-value');
            if (val) val.textContent = p.textContent.trim();
          }
        });
        mutObs.observe(priceContainer, { childList: true, subtree: true, characterData: true });
      }
    } catch(e) { console.warn('EBP mobile: sticky price skipped', e); }

    /* ---- 2. MOVE TRUST BADGES RIGHT AFTER SERVICE BADGES ---- */
    try {
      var uspEl = document.querySelector('.usps-icon-main');
      var trustDiv = document.querySelector('.trust-badges-section');

      if (uspEl && trustDiv) {
        // Move the inner trust-badges-section div right after the usps-icon-main div
        // This places it inside the same parent container
        uspEl.parentNode.insertBefore(trustDiv, uspEl.nextSibling);
      }
    } catch(e) { console.warn('EBP mobile: badge move skipped', e); }

    /* ---- 3. FIX QTY +/- BUTTONS ---- */
    try {
      document.querySelectorAll('.pro-quantity .plus, .pro-quantity .minus').forEach(function(btn) {
        btn.style.display = 'inline-flex';
        btn.style.alignItems = 'center';
        btn.style.justifyContent = 'center';
        btn.style.WebkitAppearance = 'none';
        btn.style.appearance = 'none';
      });
    } catch(e) { console.warn('EBP mobile: qty fix skipped', e); }

  });
})();